import { ACTION_CASHOUT_REGISTER, ACTION_CASHOUT_REGISTER_ERROR, ACTION_CASHOUT_REGISTER_SUCCESS } from "../actions";

const initState = {
    isLoading: false,
    erro_msg: undefined,
    data: undefined
}


export const cashoutRegisterReducer = (state = initState, action = {}) => {
    switch (action.type) {
        case ACTION_CASHOUT_REGISTER:
            return { ...state, isLoading: true, erro_msg: undefined, data: undefined }
        case ACTION_CASHOUT_REGISTER_SUCCESS:
            return { ...state, isLoading: false, erro_msg: undefined, data: action.payload.data }
        case ACTION_CASHOUT_REGISTER_ERROR:
            return { ...state, isLoading: false, erro_msg: action.payload.msg };
        default:
            return state;
    }
}